import { type FC } from "react";
import { useTranslation } from "react-i18next";
import OrganicDateRangePicker from "src/components/common/OrganicDateRangePicker/OrganicDateRangePicker";
import SelectMenu from "src/components/common/SelectMenu/SelectMenu";
import type { EngagementOverviewFilterState } from "../../Hooks/UseEngagementOverviewFilters";

export interface EngagementOverviewHeaderProps {
  title: string;
  subtitle: string;
}

export const EngagementOverviewHeader: FC<EngagementOverviewHeaderProps> = ({ title, subtitle }) => (
  <header className="engagement-overview-header">
    <div className="engagement-overview-header__copy">
      <h1 className="engagement-overview-header__title">{title}</h1>
      <p className="engagement-overview-header__subtitle">{subtitle}</p>
    </div>
  </header>
);

export interface EngagementFiltersBarProps {
  filters: EngagementOverviewFilterState;
  campaignOptions: Array<{ value: string; label: string }>;
  onRangeChange: (_range: { startDate: string; endDate: string }) => void;
  onCampaignChange: (_campaignId: string) => void;
  ariaLabel?: string;
}

export const EngagementFiltersBar: FC<EngagementFiltersBarProps> = ({
  filters,
  campaignOptions,
  onRangeChange,
  onCampaignChange,
  ariaLabel,
}) => {
  const { t } = useTranslation();
  return (
  <section className="engagement-overview-filters" aria-label={ariaLabel ?? t("engagementOverview.filtersAria")}>
    <div className="engagement-overview-filters__column">
      <div className="engagement-overview-filters__dates">
        <OrganicDateRangePicker
          startDate={filters?.startDate ?? ""}
          endDate={filters?.endDate ?? ""}
          onRangeChange={onRangeChange}
        />
      </div>
      <div className="engagement-overview-filters__campaign">
        <SelectMenu
          value={filters?.campaignId ?? "all"}
          options={campaignOptions ?? []}
          onChange={onCampaignChange}
          ariaLabel={t("engagementOverview.filterCampaignName")}
          className="engagement-overview-filters__select"
        />
      </div>
    </div>
  </section>
  );
};
